import type { CalendarProps } from '@/components/shadcn/calendar'

const DEFAULT_FROM_YEAR = 1900
const FUTURE_YEAR_OFFSET = 10

type DatePickerCalendarProps = Pick<CalendarProps, 'captionLayout' | 'fromYear' | 'toYear' | 'defaultMonth'>

export function getDatePickerCalendarProps(selectedDate?: Date): DatePickerCalendarProps {
  const currentYear = new Date().getFullYear()

  return {
    captionLayout: 'dropdown',
    fromYear: DEFAULT_FROM_YEAR,
    toYear: currentYear + FUTURE_YEAR_OFFSET,
    defaultMonth: selectedDate ?? new Date(),
  }
}
